var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.805,
    height: 62.805,
    viewBox: "0 0 62.805 62.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 18.634,
    height: 21.57,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7326",
    "data-name": "Group 7326",
    transform: "translate(-515.362 -801.362)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 62.805,
    height: 62.805,
    rx: 31.402,
    transform: "matrix(1, 0, 0, 1, 515.362, 801.362)",
    fill: "#f84525"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "matrix(1, 0, 0, 1, 540.411, 822.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M3.337,0a1.428,1.428,0,0,0,.41.108,3.8,3.8,0,0,1,.873.4q6.258,3.856,12.515,7.715A2.967,2.967,0,0,1,17.11,13.4q-4.079,2.487-8.151,4.987c-.275.168-.556.326-.823.507a.862.862,0,0,1-1.285-.213.888.888,0,0,1,.407-1.242c2.688-1.63,5.364-3.278,8.044-4.92.328-.2.66-.4.985-.6A1.258,1.258,0,0,0,16.65,10a1.5,1.5,0,0,0-.388-.319L3.659,1.909a1.226,1.226,0,0,0-1.332-.047,1.232,1.232,0,0,0-.636,1.152q0,7.742,0,15.483a1.306,1.306,0,0,0,1.127,1.375,1.257,1.257,0,0,0,.8-.2.843.843,0,0,1,.88,1.438,2.872,2.872,0,0,1-3.468-.261A2.928,2.928,0,0,1,.007,18.626C0,17.888,0,17.151,0,16.414Q0,9.757,0,3.1A3,3,0,0,1,.785.95a2.983,2.983,0,0,1,1.647-.9c.038-.008.087.009.1-.046Z",
    transform: "translate(0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/Video_Icon.50c88f7c545919824a245e94702a88df.svg";
export { ForwardRef as ReactComponent };